import {Injectable} from "@angular/core";

/**
 * Class representing the localization config
 */
@Injectable({
    providedIn: 'root'
})
export class LocalizationServiceConfig {
    public locale_id: string = 'fr-FR';
}
